import Alert from '@r1-frontend/ui-react/components/Alert';
import { WithSkeleton } from '@r1-frontend/ui-react/components/loaders/Skeleton';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';

import ConnectedOnlineCinemas from '~/src/features/tariffBuilder/components/alerts/ConnectedOnlineCinemas';
import ConnectedTvPackages from '~/src/features/tariffBuilder/components/alerts/ConnectedTvPackages';
import { useCtxSelector } from '~/src/features/tariffBuilder/hooks';
import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import selectConnectedSubscriptionsNames from '~/src/features/tariffBuilder/selectors/selectConnectedSubscriptionsNames';
import selectCurrentTariff from '~/src/features/tariffBuilder/selectors/selectCurrentTariff';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

type TConnectedEntitiesContainerProps = {
    entityName: EEntity.tv | EEntity.onlineCinemas,
}

const Alerts = {
    [EEntity.tv]: ConnectedTvPackages,
    [EEntity.onlineCinemas]: ConnectedOnlineCinemas,
};

const ConnectedEntitiesContainer = ({ entityName }: TConnectedEntitiesContainerProps) => {
    const {
        currentTariff,
        connectedSubscriptions,
    } = useCtxSelector((state: TInitialState) => {
        const subscriptionsNames = selectConnectedSubscriptionsNames(state);

        return {
            currentTariff: selectCurrentTariff(state),
            connectedSubscriptions: subscriptionsNames[entityName] ?? null,
        };
    });

    if (!currentTariff) {
        return null;
    }

    const AlertText = Alerts[entityName];

    return (
        <WithSkeleton
            height={80}
            className={'react-skeleton-flex-1'}
        >
            {connectedSubscriptions && <IndentContainer $united={[0, 0, 24]}>
                <Alert type={'info'}>
                    <Paragraph4>
                        <AlertText
                            length={connectedSubscriptions.length}
                            names={connectedSubscriptions.names}
                        />
                    </Paragraph4>
                </Alert>
            </IndentContainer>}
        </WithSkeleton>
    );
};

export default ConnectedEntitiesContainer;
